import { render, staticRenderFns } from "./CardsListForTraver.vue?vue&type=template&id=1c92eb8f"
import script from "./CardsListForTraver.vue?vue&type=script&lang=js"
export * from "./CardsListForTraver.vue?vue&type=script&lang=js"
import style0 from "./CardsListForTraver.vue?vue&type=style&index=0&id=1c92eb8f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports